/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NbChatModule,
  NbDatepickerModule,
  NbDialogModule,
  NbMenuModule,
  NbSidebarModule,
  NbToastrModule,
  NbWindowModule,
} from '@nebular/theme';
import { APP_BASE_HREF } from '@angular/common';
import { LoginService } from './_services/login.service';
import { AuthGuard } from './auth.guard';
import { AuthService } from './utils/auth.service';
import { NbPasswordAuthStrategy, NbAuthModule, NbAuthJWTToken, NbAuthSimpleToken } from '@nebular/auth';
import * as urls from './globals/links';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbToastrModule.forRoot(),
    NbChatModule.forRoot({
      messageGoogleMapKey: 'AIzaSyA_wNuCzia92MAmdLRzmqitRGvCF7wCZPY',
    }),
    CoreModule.forRoot(),
    ThemeModule.forRoot(),
    NbAuthModule.forRoot({
      strategies: [
        NbPasswordAuthStrategy.setup({
          name: 'email',
          baseEndpoint: urls.get_Service_Layer_Url,
          token: {
            class: NbAuthSimpleToken,
           
            key: 'authToken', // this parameter tells where to look for the token
          },
          login: {
            // ...
            endpoint: 'login',
            
            redirect: {
              success: '/pages/dashboard',
              failure: null, // stay on the same page
            },
            defaultErrors: ['Login/Email combination is not correct, please try again.'],
   defaultMessages: ['You have been successfully logged in.'],
          },
        }),
      ],
      forms: {
        login: {
          redirectDelay: 1000,
          showMessages: {
            success: true,
          },
        }
      },
    }),
  ],
  providers:[
    { provide: APP_BASE_HREF, useValue: '/' },
    { provide: HTTP_INTERCEPTORS, useClass: AuthService, multi: true },
    LoginService,AuthGuard,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
